import * as React from 'react'
import BigNumber from 'bignumber.js'
import Decimal from 'decimal.js'
import styled from 'styled-components'
import classNames from 'classnames'

const Wrapper = styled.div`
  svg {
    display: block;
    transform: rotate(-90deg);
  }
`

interface RadiusType {
  i: number
  o: number
}

export interface CircleProps {
  className?: string
  circleSize: number
  circleStroke?: string
  strokeWidth: number
  strokeColor: string[]
  percentArray: number[]
}

const Circle: React.FC<CircleProps> = (props: CircleProps) => {
  const { className, circleSize, circleStroke = '#383838', strokeWidth, strokeColor, percentArray } = props

  const classes = classNames(className)

  // const [fulfil, setFulfil] = React.useState<boolean>(false) // 100%
  const [fulfil, setFulfil] = React.useState<number>(-1) // 100%
  const [radius, setRadius] = React.useState<RadiusType>()
  const [renderList, setRenderList] = React.useState([])

  const getPath = (cur) => {
    const { isLargeArc, startX, startY, endX, endY } = cur

    const str = `M ${startX} ${startY} A ${radius?.i} ${radius?.i} 0 ${isLargeArc} 1 ${endX} ${endY}`
    // console.log(str)
    return str
  }

  React.useEffect(() => {
    const handleChartData = () => {
      if (!radius) return
      const newList: any = []
      for (let index = 0; index < percentArray.length; index++) {
        const item = percentArray[index]
        const obj = {
          index,
          isLargeArc: 0,
          per: 0,
          startX: 0,
          startY: 0,
          endX: 0,
          endY: 0,
        }
        let per = item
        obj.isLargeArc = per > 50 ? 1 : 0

        if (index !== 0) {
          per += newList[index - 1].per
        }
        obj.per = per
        if (index === 0) {
          // obj.startX = Math.cos(0) * radius.i + radius.o
          // obj.startY = Math.sin(0) * radius.i + radius.o
          obj.startX = new BigNumber(new Decimal(0).cos().toString()).multipliedBy(radius.i).plus(radius.o).toNumber()
          obj.startY = new BigNumber(new Decimal(0).sin().toString()).multipliedBy(radius.i).plus(radius.o).toNumber()
        } else {
          obj.startX = newList[index - 1].endX
          obj.startY = newList[index - 1].endY
        }
        // obj.endX = Math.cos((per / 100) * PI * 2) * radius.i + radius.o
        // obj.endY = Math.sin((per / 100) * PI * 2) * radius.i + radius.o
        const PI = new BigNumber(per).dividedBy(100).multipliedBy(Math.PI).multipliedBy(2).toString()
        obj.endX = new BigNumber(new Decimal(PI).cos().toString()).multipliedBy(radius.i).plus(radius.o).toNumber()
        obj.endY = new BigNumber(new Decimal(PI).sin().toString()).multipliedBy(radius.i).plus(radius.o).toNumber()

        newList.push(obj)
      }

      // console.log(JSON.stringify(newList))
      setRenderList(newList)
    }

    handleChartData()
  }, [percentArray, radius])

  React.useEffect(() => {
    const outerRadius = new BigNumber(circleSize).dividedBy(2).toNumber()
    const insideRadius = new BigNumber(circleSize).minus(strokeWidth).dividedBy(2).toNumber()
    // const total = percentArray.reduce((acc, cur) => acc + cur, 0)
    // console.log(total)

    setRadius({ i: insideRadius, o: outerRadius })
    // console.log(outerRadius, insideRadius)
    // setFulfil(total >= 100)
    let total = 0
    for (let i = 0; i < percentArray.length; i++) {
      const element = percentArray[i]
      if (i === 0 && element >= 100) {
        setFulfil(0)
        return
      }
      total += element
      if (total >= 100) {
        setFulfil(i)
        return
      }
    }
  }, [circleSize, percentArray, strokeWidth])

  return (
    <Wrapper className={classes}>
      <svg width={circleSize} height={circleSize} viewBox={`0 0 ${circleSize} ${circleSize}`}>
        <circle
          strokeWidth={strokeWidth}
          strokeLinecap="square"
          fill="transparent"
          // stroke={fulfil ? strokeColor[strokeColor.length - 1] : circleStroke}
          stroke={fulfil === -1 ? circleStroke : strokeColor[fulfil]}
          r={radius?.i}
          cx={radius?.o}
          cy={radius?.o}
        />
        {renderList.map((ele, i) => (
          <path key={ele.index} d={getPath(ele)} stroke={strokeColor[i]} strokeWidth={strokeWidth} fill="none" />
        ))}
      </svg>
    </Wrapper>
  )
}

export default Circle
